module.exports = __webpack_public_path__ + "static/img/computer.9a6425bb.png";